import React from "react";
import { connect } from "react-redux";

import RedirectToErrorPage from "./RedirectToErrorPage";
import { signOut } from "store/slices/authSlice";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log error to a logging service
    console.error(error, errorInfo);
    this.props.signOut();
  }

  render() {
    if (this.state.hasError) {
      // Render fallback UI
      return <RedirectToErrorPage />;
    }

    return this.props.children;
  }
}

const mapDispatchToProps = (dispatch) => ({
  signOut: () => dispatch(signOut()),
});

export default connect(null, mapDispatchToProps)(ErrorBoundary);
